import type { EntryStatus, MovementType, ReservationStatus } from '../../types/api';

/**
 * Textos y tonos del dominio de inventario.
 *
 * Viven aparte de las pantallas porque los comparten cinco vistas y porque
 * exportar constantes junto a un componente rompe el refresco en caliente.
 */
export const MOVEMENT_TYPE_LABELS: Record<MovementType, string> = {
  PURCHASE_ENTRY: 'Entrada por compra',
  TRANSFER_OUT: 'Salida por traslado',
  TRANSFER_IN: 'Ingreso por traslado',
  CONSUMPTION: 'Consumo en obra',
  RETURN: 'Devolución',
  SURPLUS: 'Excedente',
  DAMAGED: 'Material danado',
  ADJUSTMENT_IN: 'Ajuste positivo',
  ADJUSTMENT_OUT: 'Ajuste negativo',
  RESERVATION: 'Reserva',
  RESERVATION_RELEASE: 'Liberacion de reserva',
};

/** Movimientos que suman al saldo fisico. Decide el signo que ve el usuario. */
export const INBOUND_MOVEMENT_TYPES: MovementType[] = [
  'PURCHASE_ENTRY',
  'TRANSFER_IN',
  'RETURN',
  'SURPLUS',
  'ADJUSTMENT_IN',
];

export const ENTRY_STATUS_LABELS: Record<EntryStatus, string> = {
  DRAFT: 'Borrador',
  APPLIED: 'Aplicada',
  REVERSED: 'Revertida',
};

export const ENTRY_STATUS_TONES: Record<EntryStatus, 'neutral' | 'success' | 'warning' | 'danger'> =
  {
    DRAFT: 'neutral',
    APPLIED: 'success',
    REVERSED: 'danger',
  };

export const RESERVATION_STATUS_LABELS: Record<ReservationStatus, string> = {
  ACTIVE: 'Activa',
  PARTIALLY_CONSUMED: 'Consumida en parte',
  CONSUMED: 'Consumida',
  RELEASED: 'Liberada',
};
